<template>
  <div :class="['df-root', type === 'openIssue' ? 'df-root--panel' : 'df-root--inline']">
    <!-- ── HEADER ── -->
    <div class="df-header">
      <div class="df-header__left">
        <div class="df-header__icon-wrap">
          <v-icon size="14" color="#6366f1">mdi-tune-variant</v-icon>
        </div>
        <div class="df-header__title-group">
          <span class="df-header__title">Filters</span>
          <span class="df-header__sub">Narrow down results</span>
        </div>
      </div>
      <div class="df-header__actions">
        <button class="df-clear-btn" @click="clearAll" title="Clear all filters">
          <v-icon size="12" color="#94a3b8">mdi-refresh</v-icon>
          <span>Clear</span>
        </button>
        <button
          v-if="type === 'openIssue'"
          class="df-apply-btn"
          @click="$emit('applyChange', formData.filterData)"
        >
          <v-icon size="12" color="#fff">mdi-check</v-icon>
          <span>Apply</span>
        </button>
      </div>
    </div>

    <!-- ── DIVIDER ── -->
    <div class="df-divider" />

    <!-- ── BODY ── -->
    <div class="df-body">

      <!-- Work Timing -->
      <div
        class="df-field"
        v-if="type === 'openIssue' && type2 === 'live'"
      >
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-clock-outline</v-icon>
          Work Timing
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="worktimingData"
          item-title="name"
          item-value="id"
          density="compact"
          placeholder="Select work timing"
          v-model="formData.filterData.work_timing_id"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Work Space -->
      <div class="df-field" v-if="type === 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-domain</v-icon>
          Workspace
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="workspaceData"
          item-title="name"
          item-value="id"
          density="compact"
          placeholder="Select workspace"
          v-model="formData.filterData.work_space_id"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Account -->
      <div class="df-field" v-if="type === 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-briefcase-outline</v-icon>
          Account
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="accountData"
          item-title="name"
          item-value="id"
          density="compact"
          placeholder="Select account"
          v-model="formData.filterData.account_id"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Project -->
      <div class="df-field" v-if="type === 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-folder-outline</v-icon>
          Project
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="projectData"
          item-title="name"
          item-value="id"
          density="compact"
          placeholder="Select project"
          v-model="formData.filterData.project_id"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Stage -->
      <div class="df-field" v-if="!type2">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-layers-outline</v-icon>
          Stage
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="stageData"
          item-title="name"
          item-value="code"
          density="compact"
          placeholder="Select stage"
          v-model="formData.filterData.stages"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- User -->
      <div class="df-field" v-if="!type || type !== 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-account-outline</v-icon>
          User
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="users"
          item-value="id"
          item-title="name"
          density="compact"
          placeholder="Select user"
          v-model="formData.filterData.user_id"
          class="df-autocomplete"
          @update:model-value="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Category -->
      <div class="df-field">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-tag-outline</v-icon>
          Category
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="categoryData"
          item-value="id"
          item-title="name"
          density="compact"
          placeholder="Select category"
          v-model="formData.filterData.category_id"
          class="df-autocomplete"
          @change="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Sub Category -->
      <div class="df-field">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-tag-multiple-outline</v-icon>
          Sub Category
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="subCategoryData"
          item-value="id"
          item-title="name"
          density="compact"
          placeholder="Select sub-category"
          v-model="formData.filterData.sub_category_id"
          class="df-autocomplete"
          @change="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Sub Task -->
      <div class="df-field" v-if="!type || type !== 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-checkbox-marked-circle-outline</v-icon>
          Sub Task
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="taskData"
          item-value="id"
          item-title="name"
          density="compact"
          placeholder="Select sub task"
          v-model="formData.filterData.task_id"
          class="df-autocomplete"
          @change="$emit('filterchanged', formData.filterData)"
        />
      </div>

      <!-- Task Type -->
      <div class="df-field" v-if="!type || type !== 'openIssue'">
        <div class="df-field__label">
          <v-icon size="11" color="#6366f1">mdi-shape-outline</v-icon>
          Task Type
        </div>
        <AutoComplete
          hide-details
          multiple
          :items="issyeTypeData"
          item-value="id"
          item-title="name"
          density="compact"
          placeholder="Select task type"
          v-model="formData.filterData.issue_type_id"
          class="df-autocomplete"
          @change="$emit('filterchanged', formData.filterData)"
        />
      </div>

    </div>

    <!-- ── FOOTER (panel mode only) ── -->
    <div class="df-footer" v-if="type === 'openIssue'">
      <span class="df-footer__hint">
        <v-icon size="11" color="#94a3b8">mdi-information-outline</v-icon>
        Changes apply after pressing Apply
      </span>
    </div>
  </div>
</template>

<script>
import AutoComplete from "@/components/ui/AutoComplete.vue";
import ProjectService from "@/api/service/Project/ProjectService";
import WorkSpaceService from "@/api/service/WorkSpace/WorkSpaceService";
import AccountService from "@/api/service/Account/AccountService";
import CategoryService from "@/api/service/Category/CategoryService";
import SubCategoryService from "@/api/service/SubCategory/SubCategoryService";
import TaskService from "@/api/service/Task/TaskService";
import IssueTypeService from "@/api/service/IssueType/IssueTypeService";
import StageService from "@/api/service/Stage/StageService";
import UserService from "@/api/service/UserService";
import WorkTimingService from "@/api/service/WorkTiming/WorkTimingService";
import commonService from "@/common.service";

export default {
  props: ["showDrawer", "existFilterData", "showApply", "type", "process", "type2"],
  components: { AutoComplete },
  data() {
    return {
      drawer: true,
      projectData: [],
      accountData: [],
      categoryData: [],
      subCategoryData: [],
      issyeTypeData: [],
      taskData: [],
      users: [],
      stageData: [],
      workspaceData: [],
      worktimingData: [],
      formData: {
        filterData: {
          project_id: null,
          account_id: null,
          category_id: null,
          user_id: null,
          sub_category_id: null,
          task_id: null,
          issue_type_id: null,
          created: null,
          end_date: null,
          work_space_id: null,
          stages: null,
          next_action: null,
          workTimingId: null,
          work_timing_id: null,
        },
      },
      filterData1: {},
    };
  },
  watch: {
    existFilterData() {
      this.setFormData(this.existFilterData || null);
    },
    filterData1() {
      this.setFormData(this.filterData1 || null);
    },
    filterData() {
      this.$emit("filterchanged", this.formData.filterData);
    },
    showDrawer() {
      this.drawer = this.showDrawer;
    },
  },
  created() {
    this.getStageData();
    this.getWorkspaceData();
    this.getWorktimingData();
    this.getProjects();
    this.getAccountData();
    this.getCategoryData();
    this.getSubCategoryData();
    this.getTaskData();
    this.getIssueTypeData();
    this.getFilterData();
    this.getuser();
    this.setFormData(this.existFilterData || null);
  },
  methods: {
    clearAll() {
      this.setFormData(null);
      this.$emit("filterchanged", this.formData.filterData);
    },
    setFormData(data) {
      this.formData = {
        filterData: {
          project_id:      data?.project_id      ?? null,
          account_id:      data?.account_id      ?? null,
          category_id:     data?.category_id     ?? null,
          user_id:         data?.user_id         ?? null,
          sub_category_id: data?.sub_category_id ?? null,
          task_id:         data?.task_id         ?? null,
          issue_type_id:   data?.issue_type_id   ?? null,
          created:         data?.created         ?? null,
          end_date:        data?.end_date         ?? null,
          work_space_id:   data?.work_space_id    ?? null,
          stages:          data?.stages           ?? null,
          next_action:     data?.next_action      ?? null,
          workTimingId:    data?.workTimingId      ?? null,
          work_timing_id:  data?.work_timing_id   ?? null,
        },
      };
    },
    getFilterData() {
      let data = localStorage.getItem("filterData");
      this.filterData1 =
        data && data !== "undefined" ? JSON.parse(data) : {};
      if (this.filterData1) {
        this.formData.filterData = this.filterData1 || {};
      }
    },
    async getWorktimingData() {
      await WorkTimingService.findAll().then(async ($options) => {
        this.worktimingData =
          $options.length > 0 ? await commonService.getSort($options, "name", "asc") : [];
      });
    },
    async getWorkspaceData() {
      await WorkSpaceService.getWorkSpaceByUser().then(async ($options) => {
        this.workspaceData =
          $options.length > 0 ? await commonService.getSort($options, "name", "asc") : [];
      });
    },
    async getProjects() {
      await ProjectService.findAll().then(async ($options) => {
        this.projectData =
          $options.length > 0 ? await commonService.getSort($options, "name", "asc") : [];
      });
    },
    async getAccountData() {
      await AccountService.findAll().then(async ($options) => {
        this.accountData =
          $options.length > 0 ? await commonService.getSort($options, "name", "asc") : [];
      });
    },
    async getCategoryData() {
      let res = await CategoryService.findAll();
      this.categoryData = res.length > 0 ? res : [];
    },
    async getSubCategoryData() {
      let res = await SubCategoryService.findAll();
      this.subCategoryData = res.length > 0 ? res : [];
    },
    async getTaskData() {
      let res = await TaskService.findAll({ task_type: "production" });
      this.taskData =
        res.length > 0 ? await commonService.getSort(res, "name", "asc") : [];
    },
    async getIssueTypeData() {
      let res = await IssueTypeService.findAll();
      this.issyeTypeData = res.length > 0 ? res : [];
    },
    async getuser() {
      try {
        let res = await UserService.findAll();
        this.users = res.length ? res : [];
      } catch {
        this.users = [];
      }
    },
    async getStageData() {
      let res = await StageService.findAll();
      this.stageData = res;
    },
    close() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
/* ── ROOT ── */
.df-root {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  font-family: inherit;
}

.df-root--panel {
  width: 100%;
  max-height: 80vh;
  box-shadow: 0 8px 32px rgba(99, 102, 241, 0.12), 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid rgba(99, 102, 241, 0.12);
}

.df-root--inline {
  width: 100%;
  height: 100%;
  border: 1px solid #e9edf5;
}

/* ── HEADER ── */
.df-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  background: linear-gradient(135deg, #fafbff 0%, #f5f3ff 100%);
  border-bottom: 1px solid rgba(99, 102, 241, 0.08);
  flex-shrink: 0;
}

.df-header__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.df-header__icon-wrap {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border: 1px solid rgba(99, 102, 241, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.df-header__title-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.df-header__title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.2px;
  line-height: 1.2;
}

.df-header__sub {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 400;
  line-height: 1;
}

.df-header__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.df-clear-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.df-clear-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
}

.df-apply-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 0 12px;
  border: none;
  background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
}
.df-apply-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
}
.df-apply-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.25);
}

/* ── DIVIDER ── */
.df-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.12), transparent);
  flex-shrink: 0;
}

/* ── BODY ── */
.df-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── FIELD ── */
.df-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.df-field__label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10.5px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

/* AutoComplete override — slim, pill-bordered look */
.df-autocomplete :deep(.v-field) {
  border-radius: 10px !important;
  border: 1.5px solid #e8edf5 !important;
  background: #fafbff !important;
  box-shadow: none !important;
  min-height: 34px !important;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.df-autocomplete :deep(.v-field:hover) {
  border-color: #c7d2fe !important;
}
.df-autocomplete :deep(.v-field--focused) {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1) !important;
}
.df-autocomplete :deep(.v-field__input) {
  font-size: 12px !important;
  color: #1e293b !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  min-height: 34px !important;
}
.df-autocomplete :deep(.v-field__outline) {
  display: none !important;
}
.df-autocomplete :deep(input::placeholder) {
  color: #a0aec0 !important;
  font-size: 11.5px !important;
}
/* chips inside multi-select */
.df-autocomplete :deep(.v-chip) {
  background: #eef2ff !important;
  color: #4f46e5 !important;
  font-size: 10px !important;
  height: 20px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

/* ── FOOTER ── */
.df-footer {
  flex-shrink: 0;
  padding: 10px 16px 12px;
  border-top: 1px solid #f1f5f9;
  background: #fafbff;
}

.df-footer__hint {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
}

/* ── SCROLLBAR ── */
.df-body::-webkit-scrollbar         { width: 3px; }
.df-body::-webkit-scrollbar-track   { background: transparent; }
.df-body::-webkit-scrollbar-thumb   { background: #e2e8f0; border-radius: 4px; }
.df-body::-webkit-scrollbar-thumb:hover { background: #cbd5e1; }
</style>
